import { useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";
import type { User } from "@/lib/humhub-api/types";

interface LogoutMessage {
  type: string;
  source?: string;
  sessionId?: string;
  timestamp?: number;
}

export const useGlobalLogoutListener = () => {
  const auth = useAuth();
  const [userInfo, setUserInfo] = useState<User | null>(null);

  useEffect(() => {
    const handleLogout = (data: LogoutMessage) => {
      if (data?.type === "GLOBAL_LOGOUT") {
        try {
          // OIDC状態をクリア
          if (auth?.user) {
            auth.removeUser();
          } else {
            console.log("ℹ️ No OIDC user to remove");
          }

          // stateのユーザー情報をクリア
          setUserInfo(null);

          // ホームページに移動
          window.location.href = "/";
        } catch (error) {
          console.error("❌ Error during global logout processing:", error);
        }
      }
    };

    const handleLogoutMessage = (event: MessageEvent) => {
      // オリジンチェック
      if (event.origin !== window.location.origin) {
        console.warn("⚠️ Origin mismatch - ignoring message:", {
          received: event.origin,
          expected: window.location.origin,
        });
        return;
      }

      handleLogout(event.data);
    };

    // 🎯 BroadcastChannel リスナーを追加
    let broadcastChannel: BroadcastChannel | null = null;
    if ("BroadcastChannel" in window) {
      broadcastChannel = new BroadcastChannel("dolphin-global-logout");
      broadcastChannel.addEventListener("message", (event) => {
        handleLogout(event.data);
      });
    } else {
      console.warn("⚠️ BroadcastChannel not supported in this browser");
    }

    // postMessageリスナーを追加
    window.addEventListener("message", handleLogoutMessage);

    return () => {
      window.removeEventListener("message", handleLogoutMessage);
      if (broadcastChannel) {
        broadcastChannel.close();
      }
    };
  }, [auth]);

  return { userInfo, setUserInfo };
};
